@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
<div class="projectable-form-wrapper frontdoor-form"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
  >
  <lib-form-header
    [data]="formData"
    [title]="isExistingEntity ? 'View Namespace: ' : 'Create New Namespace'"
    [moreActions]="moreActions"
    (actionRequested)="headerActionRequested($event)"
    [(formView)]="formView"
  ></lib-form-header>
  <div class="integration-form-container projectable-form-container">
    @if (formView === 'simple') {
      <div class="namespace-layout form-group-row">
        <div class="form-group-column full">
          <lib-form-field-container [title]="'Namespace Details'">
            <div class="stacked-fields">

              <div class="field-row" [class.frontdoor-error-field]="domainNameInvalid">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Domain Name
                    @if (!isEditing) {
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="domainNameInvalid">
                        {{ domainNameErrorMessage || 'Must not be blank' }}
                      </span>
                    }
                  </span>
                  @if (!isEditing) { <span class="field-label-suffix">REQUIRED</span> }
                </div>
                @if (!isEditing) {
                  <input
                    class="form-field-input"
                    [class.frontdoor-error-state]="domainNameInvalid"
                    placeholder="Add your domain name."
                    [(ngModel)]="formData.name"
                    [disabled]="isEditing"
                    (keyup)="validateDomainName()"
                    autofocus
                    #nameFieldInput
                  />
                }
                @if (isEditing) {
                  <span class="field-value">{{ formData.name }}</span>
                }
              </div>

              <div class="field-row">
                <div class="field-label">
                  Description
                  <span class="field-label-suffix">OPTIONAL</span>
                </div>
                <input
                  class="form-field-input"
                  placeholder="Add a description for your namespace."
                  [(ngModel)]="formData.description"
                />
              </div>

              @if (isEditing) {
                <div class="field-row">
                  <div class="field-label">Status</div>
                  <span class="status-pill" [attr.data-status]="(formData.status || '').toLowerCase()">{{ formData.status }}</span>
                </div>
              }

              @if (waitingOnDnsInfo && formData.id) {
                <div class="newStatus">
                  <span class="spinner spinnerStyle"></span> Please wait a moment while we create your DNS configuration information.
                </div>
              }

              @if (hasDNSError) {
                <app-message
                  style="margin-top: 0px !important"
                  severity="error"
                  text="There was an error retrieving your DNS information for this namespace."
                ></app-message>
              }

              @if (hasStatusError) {
                <app-message
                  style="margin-top: 0px !important"
                  severity="error"
                  text="Your namespace has entered an error state. Please reach out to our support team at cust-support@netfoundry.io or create a new namespace."
                ></app-message>
              }

              @if (!waitingOnDnsInfo && formData.id && !hasDNSError && !hasStatusError && aRecord && cNames) {
                <div class="dns-section">
                  <mat-tab-group animationDuration="0ms">
              <mat-tab label="DNS Configuration">
                    <app-message
                      severity="info"
                    text="You can configure this by logging in to your DNS provider's dashboard, go to the DNS management section, and click Add Record.
                    Choose your CNAME (pointing a subdomain to another domain) and A Record (pointing to an IP address), fill in the required fields, and save."
                    ></app-message>
                      <div class="label">
                      1. Add a CNAME record in your DNS provider.
                    </div>
                    <app-panel styleClass="panelClass" [showHeader]="false">
                      @for (cname of this.cNames; track cname) {
                        <div class="separateCard">
                          <p><strong>Name: </strong> {{ cname.name }} <i (click)="copyText(cname.name)"  class="pi pi-copy" style="margin-left: 3px; cursor: pointer"></i></p>
                          <p><strong>Value: </strong> {{ cname.value }} <i (click)="copyText(cname.value)"  class="pi pi-copy" style="margin-left: 3px; cursor: pointer"></i></p>
                        </div>
                      }
                    </app-panel>
                    <div class="label">
                      2. Add A records in the DNS provider
                    </div>
                    <app-panel styleClass="panelClass" [showHeader]="false">
                      <div class="separateCard" >
                        <p><strong>Name: </strong> {{ aRecord.name }} <i (click)="copyText(aRecord.name)" class="pi pi-copy" style="margin-left: 3px; cursor: pointer"></i></p>
                        <p><strong>Values: </strong></p>
                        <ul>
                          @for (ip of aRecord.ipAddress; track ip) {
                            <li>{{ ip }} <i (click)="copyText(ip)"  class="pi pi-copy" style="margin-left: 3px; cursor: pointer"></i></li>
                          }
                        </ul>
                      </div>
                    </app-panel>
              </mat-tab>
              <mat-tab label="Verify Configuration">
                    <app-message
                      severity="info"
                    text="It may take our systems a few minutes to verify the DNS records after you create them. In the meantime you can check to make sure they've been created successfully using command line tools such as dig or nslookup."
                    ></app-message>
                    <div>
                <div class="label">
                  Verify CNAME Record
                </div>
                @for (cname of this.cNames; track cname) {
                  <div  >
                    <pre class="separateCard">
<code> nslookup {{ cname.name }} <i (click)="copyText('nslookup ' + cname.name)" class="pi pi-copy" style="margin-left: 3px; cursor: pointer; vertical-align: bottom;"></i></code>
                    </pre>
        </div>
                }
                <div class="label">
                  Sample Response:
                </div>
                @for (cname of this.cNames; track cname) {
                  <div>
                    <pre class="separateCard">
<code>Non-authoritive answer:</code>
<code>{{ cname.name }} canonical name = {{aRecord.name }} </code>
                    </pre>
                  </div>
                }
                <div class="label">
                  Verify A Records
                </div>
                <div >
                  <pre class="separateCard">
<code> nslookup {{ aRecord.name }} <i (click)="copyText('nslookup ' + aRecord.name)" class="pi pi-copy" style="margin-left: 3px; cursor: pointer; vertical-align: bottom;"></i></code>
                  </pre>
                </div>
                <div class="label">
                  Sample Response:
                </div>
                <div>
                  <pre class="separateCard">
<code>Non-authoritive answer:</code>
<code>Addresses:</code>
<code><ul class="cleanList" style="list-style-type: none; padding-left: 0;">@for (ip of aRecord.ipAddress; track ip) {
                      <li>{{ ip }}</li>
                    }</ul>
</code>
                  </pre>
                </div>
              </div>
              </mat-tab>
            </mat-tab-group>
                </div>
              }

            </div>
          </lib-form-field-container>
        </div>
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData"></lib-json-view>
        }
      </div>
    }

  </div>